import EnglishLocale from '@i18n/languages/en-US.json';

const LOCALES = {
	en: 'en'
};

export const getCurrentLocaleMessages = () => EnglishLocale;

export default LOCALES;
